import Audit from "../../../components/audit/audit";
import Page from "../../page";

const AuditPage = () => (
  <Page>
    <Audit />
  </Page>
);

export default AuditPage;
